import angular from 'angular';

export class AppStoreService {
    constructor() {
        'ngInject';
        this.reset();
    }

    reset() {
        this.model = {
            global: {
                isNewUser: true,
                isUserAuthenticated: false,
            },
            user: {
                email: '',
                firstName: '',
                lastName: '',
                hipaaAuthorized: false,
            },
        };
    }

    get(propName) {
        let keys = propName.split('.');
        let value = keys.reduce((model, key) => {
            return model[key];
        }, this.model);
        return angular.copy(value);
    }

    set(propName, value) {
        let keys = propName.split('.');
        keys.reduce((model, key, i) => {
            if (i < keys.length - 1) {
                return model[key];
            }
            model[key] = angular.copy(value);
        }, this.model);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/appStore.service.js